import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { AnalyticsFeatureViewed } from '@repo/platform-analytics/AnalyticsFeatureViewed';
import { ElementViewed } from '@repo/platform-analytics/ElementViewed';
import type { BranchId } from '@/shared/config/funnel/constants';
import { Content } from './Content';
import { CTAs } from './CTAs';
import { Header } from './Header';
const ANALYTICS_ENTITY_NAME = 'exit_intent_modal';
type ExitModalProps = {
  featureViewedActivityId: string;
  branchId: BranchId | null;
  onDismiss: () => void;
};
export function ExitModal(t0) {
  const $ = _c(22);
  const {
    featureViewedActivityId,
    branchId,
    onDismiss
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Backdrop className={css({
      position: "fixed",
      inset: "[0]",
      bg: "[rgba(0,0,0,0.5)]",
      zIndex: "[1000]"
    })} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      position: "fixed",
      inset: "[0]",
      zIndex: "[1001]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: "4"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      bg: "common.white",
      py: {
        base: "5",
        sm: "5",
        lg: "6"
      },
      px: {
        base: "3",
        sm: "5",
        lg: "6"
      },
      width: "[100%]",
      maxWidth: "[650px]"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== branchId) {
    t4 = branchId ? {
      page_branch_name: branchId
    } : undefined;
    $[3] = branchId;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      display: "flex",
      flexDirection: "column",
      gap: {
        base: "3",
        lg: "4"
      }
    });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onDismiss) {
    t6 = <Header onDismiss={onDismiss} />;
    $[6] = onDismiss;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Content />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== branchId || $[10] !== featureViewedActivityId) {
    t8 = <CTAs parentActivityId={featureViewedActivityId} branchId={branchId} />;
    $[9] = branchId;
    $[10] = featureViewedActivityId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== featureViewedActivityId || $[16] !== t4 || $[17] !== t9) {
    t10 = <ElementViewed entityName={ANALYTICS_ENTITY_NAME} sectionName="cardfinder_flow" eventId={featureViewedActivityId} additionalAttributes={t4}>{t9}</ElementViewed>;
    $[15] = featureViewedActivityId;
    $[16] = t4;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== featureViewedActivityId || $[20] !== t10) {
    t11 = <Dialog.Portal>{t1}<Dialog.Viewport className={t2}><Dialog.Popup className={t3}><AnalyticsFeatureViewed activityId={featureViewedActivityId} entityName={ANALYTICS_ENTITY_NAME} entitySection="cardfinder_flow">{t10}</AnalyticsFeatureViewed></Dialog.Popup></Dialog.Viewport></Dialog.Portal>;
    $[19] = featureViewedActivityId;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}